import Cookies from 'js-cookie'

const uidName ='dealerID';

export function getUid(){
    return Cookies.get(uidName) == 'undefined' ? undefined : Cookies.get(uidName);
}

export function setUid(uid){
    return Cookies.set(uidName,uid);
}

export function removeUid(){
    return Cookies.remove(uidName);
}